import { IconButton } from "@mui/material";
import { FieldArray, getIn, useFormikContext } from "formik";
import React, { useState } from "react";
import { StyledFieldArrayQuickRowWrapper, StyledFieldArrayWrap } from "../Styles";
import { whatsappCtaActionType, whatsappCtaValueAction } from "../../Utils/Constants";
import { AppMaterialIcons } from "../../../../../AppComponents/AppMaterialIcons";
import AppButton from "../../../../../AppComponents/AppButton";
import { AppErrorMessage, AppFormField, AppFormMobileField, AppFormSelectField } from "../../../../../AppComponents/Forms";
import WhatsappTextField from "./WhatsappTextField";


interface Props {
  label?: string;
  name: string;
  tooltip?: any;
  divStyle?: any;
  variablesKey?: any;
  sendValuesToParent?: (values: any) => void | undefined;
  children?: React.ReactNode;
  [otherProps: string]: any;
  disabled?: boolean;
}

const CtaButtonFieldArray: React.FC<Props> = ({
  label,
  name,
  tooltip,
  divStyle,
  variablesKey,
  sendValuesToParent,
  children,
  disabled,
  ...otherProps
}) => {
  const { values, errors, touched } = useFormikContext<any>();
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true);

  const getFilterConditions = () => {
    let a: string[] = [""];
    const tempArray = getIn(values, name);
    tempArray?.forEach((curElem: any) => {
      if (curElem?.["action_type"] === "URL") {
        a.push("URL");
      }
      if (curElem?.["action_type"] === "PHONE_NUMBER") {
        a.push("PHONE_NUMBER");
      }
    });
    return a;
  };

  const handleAddButtonClick = (push: any) => {
    setIsDataLoading(true);

    push({
      action_type: getIn(values, name)?.[0]?.['action_type'] === 'URL' ? "PHONE_NUMBER" : "URL",
      button_text: "Click now",
      url_type: "static",
      url: "",
      phone_number: '',
    });
    setTimeout(() => {

      setIsDataLoading(false);
    }, 1000);
  };
  return (
    <StyledFieldArrayWrap style={divStyle}>
      <FieldArray name={name}>
        {({ insert, remove, push, swap, unshift, pop, replace }) => (
          <>
            {values &&
              name &&
              getIn(values, name)?.length > 0 &&
              getIn(values, name)?.map((item: any, index: number) => {
                const fieldName1: string = `${name}.${index}.action_type`;
                const fieldName2: string = `${name}.${index}.button_text`;
                const fieldName3: string = `${name}.${index}.url_type`;
                const fieldName4: string = `${name}.${index}.url`;
                const fieldName5: string = `${name}.${index}.phone_number`;
                const fieldName6: string = variablesKey;
                console.log("fieldName4", fieldName4)
                const regex = /\{\{([^}]+)\}\}/g;
                console.log("values", values?.fieldName4)
                console.log("getIn(values, ${name}.${index}.url_type)", getIn(values, `${name}.${index}.url`))
                console.log("skvbshnmsd ns vj nfsmvljsf v", (getIn(values, `${name}.${index}.url`)).match(regex))
                return (
                  <StyledFieldArrayQuickRowWrapper key={index.toString()}>
                    <AppFormSelectField
                      label="Type of action"
                      Options={whatsappCtaActionType}
                      name={fieldName1}
                      filterCondition={getFilterConditions()}
                      disabled={disabled}
                      id={getIn(values, name)?.length > 1 && index + 1 === getIn(values, name)?.length ? "add_button" : ""}
                    />
                    <AppFormField
                      label={`Button text`}
                      name={fieldName2}
                      placeholder="Book now"
                      charactersLimit={20}
                      disabled={disabled}
                    />

                    {getIn(values, `${name}.${index}.action_type`) === "URL" ? (
                      <>
                        <AppFormSelectField
                          label="Value Type"
                          Options={whatsappCtaValueAction}
                          name={fieldName3}
                          disabled={disabled}
                        />
                        {getIn(values, `${name}.${index}.url_type`) ===
                          "dynamic" ? (
                          <WhatsappTextField
                            name={fieldName4}
                            label={`URL text`}
                            placeholder="https://www.geta.ai/{{1}}"
                            charactersLimit={1024}
                            variablesKey={fieldName6}
                            variablesButtonLimit={1}
                            endVariableRequired={true}
                            disabled={disabled || getIn(values, `${name}.${index}.url`).includes("{{1}}")}
                            removeSpaceBeforAfterVariable={true}
                          />
                        ) : (
                          <AppFormField
                            name={fieldName4}
                            label={`URL text`}
                            placeholder="https://www.geta.ai"
                            charactersLimit={100}
                            disabled={disabled}
                          />
                        )}
                      </>
                    ) : null}
                    {getIn(values, `${name}.${index}.action_type`) ===
                      "PHONE_NUMBER" ? (
                      <>
                        <AppFormMobileField
                          name={fieldName5}
                          label="Mobile"
                          placeholder="+919991234567"
                          mobileCountryFormat="mobileCountryFormat"
                          disabled={disabled}
                        />
                      </>
                    ) : null}

                    {/* Remove */}
                    <div className="removeBtnBox">
                      <IconButton
                        onClick={() => remove(index)}
                        disabled={
                          (getIn(values, name)?.length > 1 ? false : true) || (disabled)
                        }
                      >
                        <AppMaterialIcons iconName={"Delete"} />
                      </IconButton>
                    </div>
                  </StyledFieldArrayQuickRowWrapper>
                );
              })}
            <AppErrorMessage
              error={getIn(errors, name)?.[0]?.action_type}
              visible={getIn(touched, name)?.[0]?.phone_number || getIn(touched, name)?.[0]?.url}
            />
            {/* Add new field at last position */}
           { getIn(values, name)?.length < 2 ? (
            <AppButton
              variant="text"
              onClick={() => {
                handleAddButtonClick(push);
              }}
              style={{ marginTop: "0.5rem", minWidth: "170px", width: "170px", border: "1px solid rgba(91, 115, 232, 1)", borderRadius: "6px" }}
              startIcon={"ri-add-line"}
              isDisabled={(getIn(values, name)?.length === 2 ? true : false) || (disabled)}
              id="add_button"
            >
              Add Button
            </AppButton>
            ) : null}
          </>
        )}
      </FieldArray>
    </StyledFieldArrayWrap>
  );
};

export default CtaButtonFieldArray;
